export default __webpack_public_path__ + "static/media/Letter D.fca8cbaf.mov";